import { type RefObject, useLayoutEffect, useRef } from 'react';

export const APP_CONTENT_HEIGHT_VAR = '--app-content-height';

/** Expose the CSS-sized scrollport height to descendants with sticky panels. */
export function useAppContentHeight(): RefObject<HTMLDivElement | null> {
  const contentRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const content = contentRef.current;
    if (!content) return;

    const publishHeight = (): void => {
      const height = `${content.clientHeight}px`;
      if (content.style.getPropertyValue(APP_CONTENT_HEIGHT_VAR) !== height) {
        // Runtime measurement exception: descendants reuse the shell height defined by CSS.
        content.style.setProperty(APP_CONTENT_HEIGHT_VAR, height);
      }
    };

    publishHeight();
    const observer =
      typeof ResizeObserver === 'undefined' ? undefined : new ResizeObserver(publishHeight);
    observer?.observe(content);

    return () => {
      observer?.disconnect();
      content.style.removeProperty(APP_CONTENT_HEIGHT_VAR);
    };
  }, []);

  return contentRef;
}
